"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function dai(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.58275 6H11.4968C14.4855 6 16.7512 7.587 17.5942 9.8955H19.125V11.2913H17.9167C17.94 11.5118 17.952 11.7368 17.952 11.9648V11.9992C17.952 12.2557 17.937 12.5093 17.907 12.7568H19.125V14.1517H17.565C16.7002 16.4288 14.4525 18 11.4975 18H6.58275V14.1517H4.875V12.7568H6.58275V11.2913H4.875V9.89625H6.58275V6ZM7.956 14.1517V16.7482H11.496C13.6815 16.7482 15.3045 15.708 16.0597 14.1517H7.956ZM16.4805 12.7568H7.956V11.2913H16.4835C16.5143 11.5215 16.5308 11.7577 16.5308 11.9992V12.033C16.5308 12.2798 16.5135 12.5205 16.4805 12.756V12.7568ZM11.4975 7.24875C13.692 7.24875 15.3202 8.31675 16.071 9.89475H7.956V7.2495H11.496L11.4975 7.24875Z", fill: color }));
}
exports["default"] = dai;
//# sourceMappingURL=dai.js.map